import React, { useContext, useCallback, useEffect } from "react";
import { Input, Button, Form, Select, Row, Col } from "antd";
import { FiltersContext } from "@CONTEXTS";

const Filters = () => {
  const { dispatch, filters } = useContext(FiltersContext);

  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: "SET_FILTERS",
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { firstName, lastName, email } = values;
    const obj = {
      firstName,
      lastName,
      email,
    };

    setFilters(obj);
  };

  useEffect(() => {
    resetFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const resetFilters = (firstName, lastName, email) => {
    dispatch({
      type: "SET_FILTERS",
      payload: { firstName, lastName, email },
    });
  };

  return (
    <Row gutter={24}>
      <Form
        layout="inline"
        style={{ width: "100%" }}
        onFinish={(values) => onFinish(values)}
      >
        <Col span={4}>
          <Form.Item label={null} name="firstName" style={{ width: 200 }}>
            <Input
              placeholder="Ad"
              allowClear
              onChange={(e) => {
                const { value } = e.target;
                const { lastName, email } = filters;
                // value yoksa (çarpı butonuna tıklanmışsa) ve barkod değeri yoksa otomatik tekrar arasın
                if (value === "") {
                  resetFilters(null, lastName, email);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label={null} name="lastName" style={{ width: 200 }}>
            <Input
              placeholder="Soyad"
              allowClear
              onChange={(e) => {
                const { value } = e.target;
                const { firstName, email } = filters;
                // value yoksa (çarpı butonuna tıklanmışsa) ve sipariş numarası değeri yoksa otomatik tekrar arasın
                if (value === "") {
                  resetFilters(firstName, null, email);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={null} name="email" style={{ width: 300 }}>
            <Input
              placeholder="E-Posta"
              allowClear
              onChange={(e) => {
                const { value } = e.target;
                const { firstName, lastName } = filters;
                // value yoksa (çarpı butonuna tıklanmışsa) ve sipariş numarası değeri yoksa otomatik tekrar arasın
                if (value === "") {
                  resetFilters(firstName, lastName, null);
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <Button type="primary" block htmlType="submit">
              Ara
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Row>
  );
};

export default Filters;
